var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4123 12L19.7123 5.71253C20.0426 5.30998 20.0138 4.72247 19.6456 4.35424C19.2773 3.986 18.6898 3.95715 18.2873 4.28753L11.9998 10.5875L5.71227 4.28753C5.30972 3.95715 4.72221 3.986 4.35398 4.35424C3.98574 4.72247 3.95689 5.30998 4.28727 5.71253L10.5873 12L4.28727 18.2875C3.89643 18.6821 3.89643 19.3179 4.28727 19.7125C4.68458 20.0967 5.31495 20.0967 5.71227 19.7125L11.9998 13.4125L18.2873 19.7125C18.6846 20.0967 19.3149 20.0967 19.7123 19.7125C20.1031 19.3179 20.1031 18.6821 19.7123 18.2875L13.4123 12Z",
    fill: "currentColor"
  })));
};

export default SvgClose;